import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { WebsiteJsonLd, OrganizationJsonLd } from "@/components/feature/SeoJsonLd";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import GuideSections from "./components/GuideSections";
import ArticleFaq from "./components/ArticleFaq";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <WebsiteJsonLd />
      <OrganizationJsonLd />
      <Header />
      <main className="flex-1">
        <Hero />
        <CategorySection />
        <GuideSections />
        <ArticleFaq />
      </main>
      <Footer />
    </div>
  );
}